;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();export const TIER_WRITE_ACTIONS = {
	connectProvider: "connect_provider",
	generalWrite: "general_write",
	inviteMembers: "invite_members",
	manualSync: "manual_sync",
} as const;

export type TierWriteAction =
	(typeof TIER_WRITE_ACTIONS)[keyof typeof TIER_WRITE_ACTIONS];

export const TIER_TIMEZONE = "America/Los_Angeles";

export const DEFAULT_TIER_DURATION_DAYS = 30;

export const PREMIUM_UPGRADE_REQUEST_COOLDOWN_MS = 24 * 60 * 60 * 1000;

export const PREMIUM_UPGRADE_REQUEST_COOLDOWN_SECONDS =
	PREMIUM_UPGRADE_REQUEST_COOLDOWN_MS / 1000;

export const WORKFLOW_FEATURES = {
	agents: "agents",
	automations: "automations",
} as const satisfies Record<string, string>;

export type WorkflowFeature =
	(typeof WORKFLOW_FEATURES)[keyof typeof WORKFLOW_FEATURES];
